import React from 'react'
import { useRouteMatch } from 'react-router'

import { Dropdown, Tooltip } from '@sketch/components'
import { isSketchVersionGreaterThan } from 'modules/versioning/utils'
import { isDraftsRoute } from 'utils/route'

interface DuplicateShareOptionProps {
  sketchVersion: string
  moreThanOneEligible?: boolean
  onClick: () => void
}

export function DuplicateShareOption(props: DuplicateShareOptionProps) {
  const { sketchVersion, moreThanOneEligible = false, onClick } = props

  /**
   *  We check whether the application is showing the
   *  drafts section here instead of prop drilling a
   *  property which can affect a lot of components until
   *  it gets here
   */
  const route = useRouteMatch()
  const isInDraftsSection = isDraftsRoute(route.path)

  const savedUsingSketch43OrGreater = isSketchVersionGreaterThan(
    sketchVersion,
    '43'
  )

  return (
    <Tooltip
      placement="top-end"
      content="To duplicate this document, save it using Sketch version 43 or later."
      disabled={savedUsingSketch43OrGreater}
    >
      <Dropdown.Item disabled={!savedUsingSketch43OrGreater} onClick={onClick}>
        {isInDraftsSection ? 'Duplicate' : 'Duplicate to My Drafts'}
        {moreThanOneEligible ? <>&hellip;</> : null}
      </Dropdown.Item>
    </Tooltip>
  )
}
